module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    staticStyle: {
      "padding-top": "120px"
    },
    attrs: {
      "id": "piano-fingers"
    }
  }, [_c('p', [_c('br'), _vm._v("This all started when I watched "), _c('em', [_vm._v("The Secret")]), _vm._v("! Little did I know I would sell my house, buy a boat, start a new business – ‘Blue Diamond Elevation’, write this book, start a YouTube channel and paint my dreams.")]), _vm._v(" "), _c('p', [_c('br'), _vm._v("Co-creating with spirit is such a nurturing and uplifting experience. I love making the mundane magical, bringing a little sparkle into people’s lives.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0